import React, { useState } from 'react';
import api from 'helpers/api';
import useGym from 'helpers/use_gym';
import useOnMount from 'helpers/use_on_mount';
import Link from 'react/components/link';
import plural from 'helpers/plural';
import usePermissions from 'helpers/use_permissions';

const NewContactUsFormSubmissionsWidget = () => {
  const gym = useGym();
  const permissions = usePermissions();
  const [pendingCount, setPendingCount] = useState(0);

  const getPendingCount = () => {
    if (!permissions.view_contact_us_submission_report) return;

    const url = `/gyms/${gym.id}/contact_us_form_submissions/unread_count`;
    api.get(url).then((response) => {
      setPendingCount(response.unread_count);
    });
  };

  useOnMount(() => {
    getPendingCount();
  });

  if (!pendingCount) return null;

  return (
    <section className="dashboard-module flex align-center space-between flex-wrap">
      <div>
        <header className="margin-bottom-8">
          <h3>New "Contact Us" form submissions</h3>
        </header>
        <div>
          There {pendingCount === 1 ? 'is' : 'are'} <strong>{pendingCount}</strong> new{' '}
          {plural('submissions', pendingCount)} ready for review.
        </div>
      </div>

      <Link
        className="margin-top-8 margin-bottom-8"
        route="gym.reports.contact_us_form_submissions"
        variant="primary"
        type="button"
        size="sm"
      >
        View Report
      </Link>
    </section>
  );
};

angular.module('gym').value('NewContactUsFormSubmissionsWidget', NewContactUsFormSubmissionsWidget);
